"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const shared_styles_1 = require("@/stylesheets/shared.styles");
/**
 * <mm-input>
 * 공용 input 요소 컴포넌트. textfield 및 파생 컴포넌트(numberfield 등)가 공유한다.
 * 라벨/헬퍼/검증/슬롯은 textfield가 담당하고, 이 컴포넌트는 순수 input 요소만 렌더한다.
 */
let Input = class Input extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.inputId = '';
        this.type = 'text';
        this.value = '';
        this.name = '';
        this.placeholder = '';
        this.ariaLabel = '';
        this.disabled = false;
        this.ariaInvalid = null;
        this.ariaDescribedBy = null;
    }
    render() {
        return (0, lit_1.html) `
      <input
        id=${(0, if_defined_js_1.ifDefined)(this.inputId || undefined)}
        type=${this.type}
        .value=${this.value}
        name=${(0, if_defined_js_1.ifDefined)(this.name || undefined)}
        placeholder=${(0, if_defined_js_1.ifDefined)(this.placeholder || undefined)}
        aria-label=${this.ariaLabel || lit_1.nothing}
        min=${(0, if_defined_js_1.ifDefined)(this.min)}
        max=${(0, if_defined_js_1.ifDefined)(this.max)}
        step=${(0, if_defined_js_1.ifDefined)(this.step)}
        ?disabled=${this.disabled}
        aria-invalid=${(0, if_defined_js_1.ifDefined)(this.ariaInvalid ?? undefined)}
        aria-describedby=${this.ariaDescribedBy ?? lit_1.nothing}
        @input=${this.handleInput}
      />
    `;
    }
    // 호스트는 포커스를 받지 않으므로 실제 input으로 넘긴다.
    focus(options) {
        this.input?.focus(options);
    }
    handleInput(event) {
        const target = event.target;
        this.value = target.value;
        event.stopPropagation();
        this.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    }
};
Input.styles = [
    shared_styles_1.resetStyles,
    (0, lit_1.css) `
      :host {
        display: flex;
        flex: 1 1 auto;
        min-width: 0;
      }

      input {
        width: 100%;
        min-width: 0;
        height: 100%;
        outline: none;
        color: var(--foreground-color);

        &:focus-visible {
          outline: 0;
        }

        &::placeholder {
          color: var(--foreground-subtle-color);
        }

        &:read-only {
          color: var(--foreground-subtle-color);
          cursor: default;
        }

        &:disabled {
          ${shared_styles_1.disabledStyles};
        }

        &[type='date'] {
          display: block;
          max-height: var(--size-48);

          &::-webkit-calendar-picker-indicator {
            width: 100%;
            opacity: 0;
            position: absolute;
            left: 0;
            bottom: 0;
          }
        }
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ attribute: 'input-id' })
], Input.prototype, "inputId", void 0);
__decorate([
    (0, decorators_js_1.property)()
], Input.prototype, "type", void 0);
__decorate([
    (0, decorators_js_1.property)()
], Input.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)()
], Input.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)()
], Input.prototype, "placeholder", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label' })
], Input.prototype, "ariaLabel", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], Input.prototype, "disabled", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-invalid' })
], Input.prototype, "ariaInvalid", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: 'aria-describedby' })
], Input.prototype, "ariaDescribedBy", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], Input.prototype, "min", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], Input.prototype, "max", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], Input.prototype, "step", void 0);
__decorate([
    (0, decorators_js_1.query)('input')
], Input.prototype, "input", void 0);
Input = __decorate([
    (0, decorators_js_1.customElement)('mm-input')
], Input);
exports.Input = Input;
//# sourceMappingURL=data:application/json;base64,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